<template>
  <div class="steps">
    <div class="inner">
      <ul class="numbers">
          <li :class="{active: currentPage == 1}">1</li>
          <li :class="{active: currentPage == 2}">2</li>
          <li :class="{active: currentPage == 3}">3</li>
          <li :class="{active: currentPage == 4}">4</li>
      </ul>
      <ul class="text">
          <li :class="{active: currentPage == 1}">Design</li>
          <li :class="{active: currentPage == 2}">Vorschau</li>
          <li :class="{active: currentPage == 3}">Deine Daten</li>
          <li :class="{active: currentPage == 4}">Fertig</li>
      </ul>
      <div class="back-to-home" v-if="currentPage == 4">
        <b-button @click="goStart()" variant="secondary">Neustart</b-button>
        <div class="back-to-home__text">Automatischer Neustart in <span>{{ timerCount }}</span> Sekunden</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Head",
  props: {
    currentPage: {
      type:Number,
      required: true
    }
  },
  data() {
    return {
      timerCount: 5,
    }
  },
  computed: {
    cssClass: function() {
      return `step-${this.currentPage}`
    }
  },
  mounted: function () {
    this.stepsCheck();
  },
  methods: {
    goStart() {
      this.$emit('start')
    },
    countDownTimer () {
      if (this.timerCount > 0) {
          setTimeout(() => {
              this.timerCount -= 1
              this.countDownTimer()
          }, 1000)
      } else {
        this.goStart()
      }
    },
    stepsCheck: function() {
      const stepsChecker = setInterval(() => {
        if(this.currentPage == 4) {
          clearInterval(stepsChecker)
          setTimeout(() => {
            this.countDownTimer()
          }, 5000)
        }
      }, 500)
    }
  }
}
</script>
<style lang="scss" scoped>
.steps {
  position: relative;
  background-color: white;
  height: 135px;
  display: flex;
  align-items: center;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
}
.inner {
  width: 100%;
}
ul {
  padding: 0;
  margin: 0;
  max-width: 460px;
  width: 100%;
  margin-left: auto;
  margin-right: auto;
  display: flex;
  justify-content: space-between;
  list-style: none;

  &.numbers {
    background-image: url('~@/assets/imgs/background-line.png');
    background-repeat: repeat-x;
    background-position: left center;
  }

  &.numbers li {
    display: inline-block;
    font-weight: bold;
    font-family: Winston;
    height: 28px;
    width: 28px;
    line-height: 28px;
    text-align: center;
    background-color: #F1F1F2;
    color: #2351A0;
    white-space: nowrap;
    &.active {
      background-color: #2351A0;
      color: #ffffff;
    }
    border-radius: 14px;
  }

  &.text {
    margin-top: 5px;
  }

  &.text li {
    color: #F1F1F2;
    font-weight: normal;
    text-align: center;
    font-size: 17px;
    &.active {
      color: #2351A0;
    }

    &:first-of-type {
      position: relative;
      left: -10px;
    }

    &:last-of-type {
      position: relative;
      left: 6px;
    }
  }
}
.back-to-home {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  padding: 20px;
  text-align: center;
  background-color: white;
}
.back-to-home__text {
  margin-top: 5px;
  color: #939393;
}
</style>
